"use strict";

import "core-js/modules/web.dom-collections.iterator.js";
import { observer } from "mobx-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import MenuPanel from "../../../StandardUserInterface/customizable/MenuPanel";
import { useViewState } from "../../../Context";
import CountDatasets from "./CountDatasets";
import Styles from "./tools-panel.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ToolsPanel = observer(() => {
  const [isOpen, setIsOpen] = useState(false);
  const [resultsMessage, setResultsMessage] = useState("");
  const dropdownTheme = {
    btn: Styles.btnShare,
    outer: Styles.ToolsPanel,
    inner: Styles.dropdownInner,
    icon: "settings"
  };
  const {
    t
  } = useTranslation();
  const viewState = useViewState();
  return /*#__PURE__*/_jsxs(MenuPanel, {
    theme: dropdownTheme,
    btnText: t("toolsPanel.btnText"),
    viewState: viewState,
    btnTitle: t("toolsPanel.btnTitle"),
    onOpenChanged: setIsOpen,
    isOpen: isOpen,
    smallScreen: viewState.useSmallScreenInterface,
    children: [isOpen && /*#__PURE__*/_jsx("div", {
      style: {
        padding: "15px"
      },
      children: /*#__PURE__*/_jsx("div", {
        className: Styles.this,
        children: /*#__PURE__*/_jsx(CountDatasets, {
          updateResults: setResultsMessage
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: Styles.results,
      children: /*#__PURE__*/_jsx("div", {
        dangerouslySetInnerHTML: {
          __html: resultsMessage
        }
      })
    })]
  });
});
export default ToolsPanel;